import * as React from "react";
import { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import CssBaseline from "@mui/material/CssBaseline";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import Typography from "@mui/material/Typography";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  ClinicIcon,
  DashboardIcon,
  ExerciseIcon,
  LogoutIcon,
  MedicationIcon,
  SettingsIcon,
} from "../Icons/Icons";
import { TopNav } from "./TopNav";
import { Chip } from "@mui/material";

const drawerWidth = 240;

export default function SideNav(props) {
  const navigate = useNavigate();
  const location = useLocation();
  const [tabName, settabName] = useState("/");
  const listItems = [
    {
      name: "Dashboard",
      route: "/dashboard",
    },
    {
      name: "Clinics",
      route: "/clinics",
    },
    {
      name: "Exercise Library",
      route: "/exercise",
    },
    {
      name: "Medications",
      route: "/medications",
    },
  ];

  const bottomListItems = [
    {
      name: "Logout",
      route: "/",
    },
  ];
  useEffect(() => {
    settabName(location.pathname);
  }, [location.pathname]);
  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <TopNav
        drawerWidth={drawerWidth}
        filterFunction={(e) => props.filterFunction(e)}
        tabName={tabName}
      />
      <Drawer
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: drawerWidth,
            boxSizing: "border-box",
            borderWidth: "0px",
          },
        }}
        variant="permanent"
        anchor="left"
        elevation={0}
      >
        <Toolbar style={{ paddingLeft: "0px" }}>
          <img
            src={require("../Images/logo.png")}
            style={{ width: "95px" }}
            alt="logo"
          />
        </Toolbar>
        <List style={{ paddingTop: "30px" }}>
          {listItems.map((text, index) => (
            <ListItem
              key={index}
              disablePadding
              style={{
                backgroundColor:
                  tabName === text.route ||
                  tabName.substring(0, 8) === text.route
                    ? "rgba(226, 64, 32, 0.1)"
                    : "white",
                marginLeft: "10px",
                width: "90%",
                borderRadius: "6px",
              }}
            >
              <ListItemButton
                component={Link}
                to={text.route}
                onClick={() => {
                  settabName(text.route);
                }}
              >
                {text.route === "/dashboard" && (
                  <DashboardIcon
                    color={
                      tabName === text.route ||
                      tabName.substring(0, 8) === text.route
                        ? "#E24020"
                        : "#5F6165"
                    }
                  />
                )}
                {text.route === "/clinics" && (
                  <ClinicIcon
                    color={
                      tabName === text.route ||
                      tabName.substring(0, 8) === text.route
                        ? "#E24020"
                        : "#5F6165"
                    }
                  />
                )}
                {text.route === "/exercise" && (
                  <ExerciseIcon
                    color={
                      tabName === text.route ||
                      tabName.substring(0, 8) === text.route
                        ? "#E24020"
                        : "#5F6165"
                    }
                  />
                )}
                {text.route === "/medications" && (
                  <MedicationIcon
                    color={
                      tabName === text.route ||
                      tabName.substring(0, 8) === text.route
                        ? "#E24020"
                        : "#5F6165"
                    }
                  />
                )}
                <Typography
                  variant="sideNavFont"
                  style={{
                    paddingLeft: "20px",
                    color:
                      tabName === text.route ||
                      tabName.substring(0, 8) === text.route
                        ? "#E24020"
                        : "#5F6165",
                  }}
                >
                  {text.name}
                </Typography>
              </ListItemButton>
            </ListItem>
          ))}
        </List>

        <List style={{ position: "absolute", bottom: 0, width: "90%" }}>
          <Chip
            size="small"
            style={{
              marginLeft: "10px",
              backgroundColor: "#edede9",
              marginBottom: "15px",
            }}
            label={`API v.${process.env.REACT_APP_API_VERSION}`}
          />
          <Chip
            size="small"
            style={{
              marginLeft: "10px",
              backgroundColor: "#edede9",
              marginBottom: "15px",
            }}
            label={`Web v.${process.env.REACT_APP_WEB_VERSION}`}
          />
          {bottomListItems.map((text, index) => (
            <ListItem
              key={index}
              disablePadding
              style={{
                backgroundColor:
                  tabName === text.route ? "rgba(226, 64, 32, 0.1)" : "white",
                marginLeft: "10px",
                width: "100%",
                borderRadius: "6px",
              }}
            >
              <ListItemButton
                component={Link}
                to={text.route}
                onClick={() => {
                  if (text.route === "/") {
                    localStorage.clear();
                    navigate("/");
                  }
                  settabName(text.route);
                }}
              >
                {text.route === "/settings" && (
                  <SettingsIcon
                    color={tabName === text.route ? "#E24020" : "#5F6165"}
                  />
                )}
                {text.route === "/" && (
                  <LogoutIcon
                    color={tabName === text.route ? "#E24020" : "#5F6165"}
                  />
                )}
                <Typography
                  variant="sideNavFont"
                  style={{
                    paddingLeft: "20px",
                    color: tabName === text.route ? "#E24020" : "#5F6165",
                  }}
                >
                  {text.name}
                </Typography>
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Drawer>
      <Box
        component="main"
        sx={{ flexGrow: 1, bgcolor: "background.default", p: 3 }}
      ></Box>
    </Box>
  );
}
